import { ButtonProps } from '@chakra-ui/react';
import { FaChevronRight } from 'react-icons/fa';
import { MIcon } from './chakra';
import MButton from './MButton';

export interface ExpandCollapseButtonProps extends Omit<
  ButtonProps,
  'onChange' | 'onClick' | 'children'
> {
  isExpanded: boolean;
  collapsedLabel?: string;
  expandedLabel?: string;
  onChange: (allExpanded: boolean) => void;
}

export const ExpandCollapseButton = ({
  isExpanded,
  collapsedLabel = 'Expand all',
  expandedLabel = 'Collapse all',
  onChange,
  ...buttonProps
}: ExpandCollapseButtonProps) => {
  return (
    <MButton
      variant="tertiary"
      size="sm"
      leftIcon={
        <MIcon
          as={FaChevronRight}
          w="2"
          h="2"
          transform={isExpanded ? 'rotate(90deg)' : undefined}
          transition="all ease 0.3s"
        />
      }
      onClick={() => onChange(!isExpanded)}
      {...buttonProps}
    >
      {isExpanded ? expandedLabel : collapsedLabel}
    </MButton>
  );
};
